import { ObjectKeys } from "@/utils/object.utils";

import { searchSliderMinMaxValues } from "../constants";
import { SearchInputsSchema } from "../models";

type AdditionalValues = {
  ageMinMax: [number, number];
  heightMinMax: [number, number];
  weightMinMax: [number, number];
};

export type LadiesSearchReqParams = ReturnType<
  typeof convertFormValuesToParams
> & {
  topLadies?: boolean;
  newest?: boolean;
  page?: number;
};

export const convertFormValuesToParams = (
  formValues:
    | (SearchInputsSchema & {
        topLadies?: boolean;
        newest?: boolean;
      })
    | null,
  additionalValues: AdditionalValues = {
    ageMinMax: searchSliderMinMaxValues.ageMinMax,
    heightMinMax: searchSliderMinMaxValues.heightMinMax,
    weightMinMax: searchSliderMinMaxValues.weightMinMax,
  },
) => {
  if (!formValues) return null;

  const { ageMinMax, heightMinMax, weightMinMax } = additionalValues;
  const params: Record<string, number[] | string | number | boolean | null> =
    {};

  if (formValues.age && formValues.age[0] > ageMinMax[0]) {
    params.minAge = formValues.age[0];
  }

  if (formValues.age && formValues.age[1] < ageMinMax[1]) {
    params.maxAge = formValues.age[1];
  }

  if (formValues.height && formValues.height[0] > heightMinMax[0]) {
    params.minHeight = formValues.height[0];
  }

  if (formValues.height && formValues.height[1] < heightMinMax[1]) {
    params.maxHeight = formValues.height[1];
  }

  if (formValues.weight && formValues.weight[0] > weightMinMax[0]) {
    params.minWeight = formValues.weight[0];
  }

  if (formValues.weight && formValues.weight[1] < weightMinMax[1]) {
    params.maxWeight = formValues.weight[1];
  }

  const formValuesKeys = ObjectKeys(formValues);
  const withUidsArray = [
    "country",
    "city",
    "children",
    "eyeColor",
    "hairColor",
    "englishSkill",
    "smoking",
    "drinking",
    "religion",
    "page",
  ];

  formValuesKeys.forEach((key) => {
    if (withUidsArray.includes(key) && !!formValues[key]) {
      params[key] = Number(formValues[key]);
    }
  });

  if (formValues.Id) {
    params.Id = Number(formValues.Id);
  }

  if (formValues.zodiacSign) {
    params.zodiacSign = formValues.zodiacSign;
  }

  if (formValues.appearanceType) {
    params.appearanceType = formValues.appearanceType;
  }

  const withBooleanKeys = [
    "birthdaySoon",
    "online",
    "hasVideo",
    "ladiesWithCam",
    "newest",
    "topLadies",
    "hasIntroVideo",
  ];

  formValuesKeys.forEach((key) => {
    if (withBooleanKeys.includes(key) && !!formValues[key]) {
      params[key] = Boolean(formValues[key]);
    }
  });

  return params;
};
